<template>
    <div id="scan_action_prototypes_layout">
        <transition v-if="is_initialized" name="slide-fade" mode="out-in" appear>
            <router-view>
            </router-view>
        </transition>
        <div v-else class="ui active centered inline large loader"></div>
        <div is="BackToTopButton"></div>
    </div>
</template>

<script>
import BackToTopButton from '@toolbox/back_to_top_button/main.vue'
export default {
    name: "ScanActionPrototypesLayout",
    data() {
        return {
            is_initialized: false,
            errors: [],
        }
    },
    computed: {
    },
    created() {
        this.init()
    },
    mounted() {
    },
    watch: {
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                resolve()
            })
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
    },
    components: {
        BackToTopButton
    }
}
</script>
<style lang="scss">
</style>
